import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import Select from "react-dropdown-select";
import questions from "./questions.json";

const NewInterestChecklistForm = ({ onCancel, onSubmit }) => {
    const [model, setModel] = useState({
        strong_interest: [],
        educational: [],
        health_fitness: [],
        sports: [],
        creatives: [],
        productivity: [],
        leisures: [],
        social: [],
        out_door: [],
        out_about: [],
        short_list: [],
        action_plans: [],
    });

    const onChangeTarget = (item, activity, interest, participation) => {
        let found = false;

        const _model = { ...model };

        for (let index = 0; index < _model[item].length; index++) {
            if (_model[item][index].activity === activity) {
                found = true;
                // update interest
                if (interest !== null) {
                    _model[item][index].interest = interest;
                }
                if (participation !== null) {
                    const idx = _model[item][index].participation.indexOf(participation);
                    if (idx !== -1) {
                        // remove existing participation
                        _model[item][index].participation.splice(idx, 1);
                    } else {
                        // add new participation
                        _model[item][index].participation.push(participation);
                    }
                }
            }
        }
        // if not found
        if (!found) {
            const _new = { activity, participation: [] };
            if (participation) _new.participation.push(participation);

            if (interest) _new.interest = interest;
            // add new one
            _model[item].push(_new);
        }

        setModel(_model);
    };

    return (
        <>
            <Helmet>
                <title> New Interest Checklist | {AppName}</title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <form
                        onSubmit={(event) => {
                            event.preventDefault();
                            onSubmit(model);
                        }}
                    >
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Licence</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>
                                            <strong className="text-danger">This assessment must only be completed by those individuals holding their own appropriate licence.</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {questions.map((item, idx) => (
                            <div key={idx} className="row">
                                <div className="col-4 bg-primary pl-2">
                                    <h5>
                                        {idx + 1}. {item.item}
                                    </h5>
                                </div>

                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "40%" }}>Activity</th>
                                            <th style={{ width: "30%" }}>Degree of Interest</th>
                                            <th style={{ width: "30%" }}>Participation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item.list.map((o, i) => (
                                            <tr key={i}>
                                                <th>{o}</th>
                                                <td>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            onChange={() => onChangeTarget(item.key, o, "Strong", null)}
                                                            type="radio"
                                                            className="custom-control-input"
                                                            name={o}
                                                            id={o + i + "strong"}
                                                        />
                                                        <label className="custom-control-label" htmlFor={o + i + "strong"}>
                                                            Strong
                                                        </label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input onChange={() => onChangeTarget(item.key, o, "Some", null)} type="radio" name={o} className="custom-control-input" id={o + i + "some"} />
                                                        <label className="custom-control-label" htmlFor={o + i + "some"}>
                                                            Some
                                                        </label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input onChange={() => onChangeTarget(item.key, o, "None", null)} type="radio" name={o} className="custom-control-input" id={o + i + "none"} />
                                                        <label className="custom-control-label" htmlFor={o + i + "none"}>
                                                            None
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <table className="table table-bordered table-hover">
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: "33.1%" }}>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input
                                                                            onChange={() => onChangeTarget(item.key, o, null, "Past")}
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id={o + i + "path"}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor={o + i + "path"}>
                                                                            Past
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td style={{ width: "33.1%" }}>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input
                                                                            onChange={() => onChangeTarget(item.key, o, null, "Present")}
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id={o + i + "present"}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor={o + i + "present"}>
                                                                            Present
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td style={{ width: "33.1%" }}>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input
                                                                            onChange={() => onChangeTarget(item.key, o, null, "Future")}
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id={o + i + "future"}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor={o + i + "future"}>
                                                                            Future
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>
                                                Other {item.item}
                                                <br />
                                                <div className="form-group">
                                                    <input placeholder={`Enter ${item.item} ...`} type="text" id={item.item + 1} className="form-control" />
                                                </div>
                                            </td>
                                            <td>
                                                <Select
                                                    key={item.item + 1}
                                                    clearable
                                                    onChange={(items) => {
                                                        const value = document.getElementById(item.item + 1).value;
                                                        onChangeTarget(item.key, value, items[0].value, null);
                                                    }}
                                                    options={[
                                                        { label: "Strong", value: "Strong" },
                                                        { label: "Some", value: "Some" },
                                                        { label: "None", value: "None" },
                                                    ]}
                                                    placeholder="-- Please Select --"
                                                    valueField="value"
                                                    labelField="label"
                                                />
                                            </td>
                                            <td>
                                                <table className="table table-bordered table-hover">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "33.1%" }}>
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 1).value;
                                                                            onChangeTarget(item.key, value, null, "Past");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "path"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "path"}>
                                                                        Past
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: "33.1%" }}>
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 1).value;
                                                                            onChangeTarget(item.key, value, null, "Present");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "present"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "present"}>
                                                                        Present
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: "33.1%" }}>
                                                                {" "}
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 1).value;
                                                                            onChangeTarget(item.key, value, null, "Future");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "future"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "future"}>
                                                                        Future
                                                                    </label>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Other {item.item}
                                                <br />
                                                <div className="form-group">
                                                    <input placeholder={`Enter ${item.item} ...`} type="text" id={item.item + 2} className="form-control" />
                                                </div>
                                            </td>
                                            <td>
                                                <Select
                                                    key={item.item + 2}
                                                    clearable
                                                    onChange={(items) => {
                                                        const value = document.getElementById(item.item + 2).value;
                                                        onChangeTarget(item.key, value, items[0].value, null);
                                                    }}
                                                    options={[
                                                        { label: "Strong", value: "Strong" },
                                                        { label: "Some", value: "Some" },
                                                        { label: "None", value: "None" },
                                                    ]}
                                                    placeholder="-- Please Select --"
                                                    valueField="value"
                                                    labelField="label"
                                                />
                                            </td>
                                            <td>
                                                <table className="table table-bordered table-hover">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "33.1%" }}>
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 2).value;
                                                                            onChangeTarget(item.key, value, null, "Past");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "path2"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "path2"}>
                                                                        Past
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: "33.1%" }}>
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 2).value;
                                                                            onChangeTarget(item.key, value, null, "Present");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "present2"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "present2"}>
                                                                        Present
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: "33.1%" }}>
                                                                {" "}
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={() => {
                                                                            const value = document.getElementById(item.item + 2).value;
                                                                            onChangeTarget(item.key, value, null, "Future");
                                                                        }}
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={item.item + "future2"}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={item.item + "future2"}>
                                                                        Future
                                                                    </label>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))}

                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Interest Summary</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td colSpan="2">
                                            <strong>Strong Interests</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="form-group">
                                                <textarea
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.strong_interest[0] = value;
                                                        setModel(_model);
                                                    }}
                                                    name="string1"
                                                    id="strong1"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="3"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="form-group">
                                                <textarea
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.strong_interest[1] = value;
                                                        setModel(_model);
                                                    }}
                                                    name="strong2"
                                                    id="strong2"
                                                    className="form-control form-control-textarea"
                                                    required
                                                    rows="3"
                                                    placeholder="Enter value here.."
                                                ></textarea>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-2">
                                <h5>Action Plan</h5>
                            </div>

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>
                                            <strong>SHORTLIST</strong>
                                        </td>
                                        <td>
                                            <strong>ACTION PLAN</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.short_list[0] = value;
                                                        setModel(_model);
                                                    }}
                                                    required
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.short_list[1] = value;
                                                        setModel(_model);
                                                    }}
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.short_list[2] = value;
                                                        setModel(_model);
                                                    }}
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.action_plans[0] = value;
                                                        setModel(_model);
                                                    }}
                                                    required
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.action_plans[1] = value;
                                                        setModel(_model);
                                                    }}
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    onChange={({ currentTarget }) => {
                                                        const { value } = currentTarget;
                                                        const _model = { ...model };
                                                        _model.action_plans[2] = value;
                                                        setModel(_model);
                                                    }}
                                                    className="form-control form-control input-height"
                                                    type="text"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-12 text-right">
                                <button type="button" onClick={() => onCancel()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle">
                                    <i className="material-icons text-danger">close</i> Close
                                </button>
                                <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle">
                                    Submit Assessment <i className="material-icons">arrow_right_alt</i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default NewInterestChecklistForm;
